import styled from '@emotion/styled';
import { Box, themeGet } from '@lightspeed/flame/Core';

export const StyledUnselected = styled(Box)`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${themeGet(`colors.${'gray-100'}`)};
  margin: 3px;
`;

export const StyledSelected = styled(Box)`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${themeGet(`colors.${'blue-500'}`)};
  margin: 3px;
`;
